export const globalVariables = {
  localPreviewDomId: null,
  localStreamId: null,
  screenStreamId: null,
};
